import React, { useState } from 'react';

import Card from '../../UI/Card';
import CasesList from '../CasesList/CasesList';
import './Cases.css';

export default function Cases({   
  title,
  cases,
  fallbackText,
  isLoading,
  loadingText,
  onSelectedCase
}) {
    
  console.log ( 'cases - cases=', cases); 

  console.log ( 'isLoading=', isLoading); 

  var x = 0;
  for (let i in cases.cases) {
    x += 1;
  }

  console.log ( 'Cases: cases.length=', x); 
  return (
    <div>
        <h2>{title}</h2>
        {isLoading && <p className="fallback-text">{loadingText}</p>}
        {!isLoading && x == 0 && <p className="fallback-text">{fallbackText}</p>}
        {!isLoading && x > 0 && ( 
            <Card className='cases'>
                <CasesList cases={cases.cases} />
            </Card>)
            }
    </div>
  );
}; 


